export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["DRAG_OVER"] = "DRAG_OVER";
    ActionTypes["DRAG_OUT"] = "DRAG_OUT";
    ActionTypes["SET_INVALID_FILE"] = "SET_INVALID_FILE";
    ActionTypes["DROP_SUCCES"] = "DROP_SUCCES";
})(ActionTypes || (ActionTypes = {}));
const reducer = (state, action) => {
    if (action.type === ActionTypes.DRAG_OVER) {
        return Object.assign(Object.assign({}, state), { dragOver: true });
    }
    if (action.type === ActionTypes.DRAG_OUT) {
        return Object.assign(Object.assign({}, state), { dragOver: false });
    }
    if (action.type === ActionTypes.SET_INVALID_FILE) {
        return Object.assign(Object.assign({}, state), { message: action.payload.message });
    }
    if (action.type === ActionTypes.DROP_SUCCES) {
        return Object.assign(Object.assign({}, state), { dragOver: false, message: action.payload.message });
    }
    return state;
};
export default reducer;
